const isBuilderImage = (url: string) => url.includes('cdn.builder.io');
const isContentfulScalableImage = (url: string) =>
    url.includes('fiverr-res.cloudinary.com') && url.includes('/upload/');

export const getImageData = (url: string, responsiveImageData: { sizes: string[]; srcSet: number[] }) => {
    if (isContentfulScalableImage(url)) {
        return {
            srcset: responsiveImageData.srcSet.map(
                (size) => `${url.split('/upload/').join(`/upload/w_${size}/`)} ${size}w`
            ),
            sizes: responsiveImageData.sizes,
        };
    } else if (isBuilderImage(url)) {
        return {
            srcset: responsiveImageData.srcSet.map((size) => `${url}?width=${size} ${size}w`),
            sizes: responsiveImageData.sizes,
        };
    }

    return { srcset: [url], sizes: [] };
};
